import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import { Nav } from '@miro-site/ui-foundation';
import { FlyoutMenu } from './flyout-menu';
import { jsx as _jsx } from "react/jsx-runtime";
export var MainMenu = function MainMenu(_ref) {
  var _menu$children;

  var menu = _ref.menu,
      _ref$menuItemsHoverBa = _ref.menuItemsHoverBackground,
      menuItemsHoverBackground = _ref$menuItemsHoverBa === void 0 ? true : _ref$menuItemsHoverBa;

  var _useState = useState(''),
      selected = _useState[0],
      setSelected = _useState[1];

  var _useState2 = useState(false),
      animated = _useState2[0],
      setAnimated = _useState2[1];

  var handleClose = function handleClose() {
    setSelected('');
  };

  return /*#__PURE__*/_jsx(Nav, {
    role: "navigation",
    className: "d-none d-xl-flex gap-200",
    "data-testid": "headerMenuWrapper",
    onMouseEnter: function onMouseEnter() {
      /**
       * Prevent animations from running multiple times.
       */
      setTimeout(function () {
        return setAnimated(true);
      }, 600);
    },
    onMouseLeave: function onMouseLeave() {
      /**
       * Set animated to false in order to allow the animations to run again
       * the next time the user hovers over the menu.
       */
      setTimeout(function () {
        return setAnimated(false);
      }, 300);
    },
    children: menu === null || menu === void 0 ? void 0 : (_menu$children = menu.children) === null || _menu$children === void 0 ? void 0 : _menu$children.flatMap(function (node) {
      return /*#__PURE__*/_jsx(FlyoutMenu, _objectSpread({
        animated: animated,
        handleClose: handleClose,
        setSelected: setSelected,
        show: selected === node.label,
        withHoverBg: menuItemsHoverBackground
      }, node), node.label);
    })
  });
};